'use client';
import { useHubSpotScript } from '@/hooks/useHubSpotScript';
import MessageDefault from '../MessageDefault/MessageDefault';

interface Props {
  consentGiven: boolean;
}

const HubSpotForm = ({ consentGiven }: Props) => {
  const loaded = useHubSpotScript(consentGiven);

  if (!consentGiven) return null;
  return loaded ? (
    <div
      className="hs-form-frame"
      data-region="na1"
      data-form-id="f5cdfae0-12fc-4a11-8cd5-001923a09faa"
      data-portal-id="14519097"
    />
  ) : null;
};

export default HubSpotForm;